import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";

const field = "w-full bg-parchment/5 border border-parchment/15 rounded-xl px-3.5 py-2.5 text-sm text-parchment placeholder:text-parchment/40 focus:outline-none focus:border-gold transition-colors";

export const ContactForm = () => {
  const [f, setF] = useState({ name: "", email: "", message: "", website: "" });
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!f.name.trim() || !f.email.trim() || !f.message.trim()) return toast.error("Please fill in your name, email and message.");
    setBusy(true);
    try {
      await api.post("/contact", f);
      setSent(true);
      setF({ name: "", email: "", message: "", website: "" });
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Please check your email address and try again.");
    } finally { setBusy(false); }
  };

  if (sent) {
    return (
      <p data-testid="contact-form-success" className="mt-5 text-sm text-gold max-w-xs">
        Thank you — your message has been sent. We'll reply soon, God willing.
      </p>
    );
  }

  return (
    <form onSubmit={submit} data-testid="contact-form" className="mt-5 space-y-2.5 max-w-xs">
      <input data-testid="contact-name" className={field} placeholder="Your name" value={f.name} onChange={set("name")} maxLength={120} />
      <input data-testid="contact-email" type="email" className={field} placeholder="Your email" value={f.email} onChange={set("email")} />
      <textarea data-testid="contact-message" className={`${field} min-h-[90px] resize-y`} placeholder="Your message" value={f.message} onChange={set("message")} maxLength={4000} />
      <input tabIndex={-1} autoComplete="off" aria-hidden="true" className="hidden" value={f.website} onChange={set("website")} />
      <button type="submit" disabled={busy} data-testid="contact-submit"
        className="inline-flex items-center gap-2 rounded-full bg-gold text-ink hover:bg-parchment font-700 text-sm px-5 py-2.5 transition-colors disabled:opacity-60">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Send Message
      </button>
    </form>
  );
};
